import {createSlice, Dispatch} from "@reduxjs/toolkit";
import {AirportService} from "app/services";
import {errorMsg, successMsg} from "app/utils/MessageUtils";
import {fetchAllAirports} from "./airports-list.slice";

interface UpdateAirportStatusParams {
  id: string;
  status: boolean;
  onSuccess?: Function;
  onError?: Function;
}

export const updateAirportStatus = (params: UpdateAirportStatusParams) => async (dispatch: Dispatch) => {
  try {
    dispatch(setLoading(true));
    const response = await AirportService.updateAirportStatus(params.id, params.status);

    if (response.status >= 200 && response.status < 300) {
      dispatch(setSuccess(true));
      dispatch(successMsg(
        localStorage.getItem('i18nextLng') === 'en'
          ? `Airport ${params.status ? 'activated' : 'deactivated'} successfully!`
          : `Aeroporti u ${params.status ? 'aktivizua' : '\u00e7aktivizua'} me sukses!`
      ));
      dispatch(setError(''));
      if (params.onSuccess) params.onSuccess();
      // @ts-ignore
      dispatch(fetchAllAirports());
    }
  } catch (err: any) {
    const message = err?.response?.data?.message || err?.data?.message || err?.message || 'Something went wrong. Please try again.';
    dispatch(errorMsg(message));
    dispatch(setError(message));
    if (params.onError) params.onError();
  } finally {
    dispatch(setLoading(false));
  }
};

interface UpdateAirportStatusSlice {
  success: boolean;
  error: string;
  loading: boolean;
}

const initialState: UpdateAirportStatusSlice = {
  error: '',
  success: false,
  loading: false
};

const stateSlice = createSlice({
  name: 'configurations/updateAirportStatus',
  initialState,
  reducers: {
    setLoading: (state, action) => {
      state.loading = action.payload;
    },
    setSuccess: (state, action) => {
      state.success = action.payload;
    },
    setError: (state, action) => {
      state.error = action.payload;
    }
  }
});

export const {setLoading, setSuccess, setError} = stateSlice.actions;

export default stateSlice.reducer;
